import React, { createContext, useContext } from 'react'

const InputGroupContext = createContext(false)

export const useInputGroupContext = () => {
  return useContext(InputGroupContext)
}

const isInInputGroup = true
export default function InputGroupProvider({ children }) {
  return <InputGroupContext.Provider value={isInInputGroup}>{children}</InputGroupContext.Provider>
}
